export default {"src":"/_next/static/media/favicon.6cc3dbe0.ico","height":96,"width":96};